module.exports = __webpack_public_path__ + "static/media/inherit-img6.59898199.png";